import React, { useEffect, useRef, useState } from 'react';
import { deletURLParam, formattedMoney, getURLParam, setURLParam, unlockBody } from '../../helpers/utilities';
import cartUtil from '../../helpers/cartUtil';
import { calculateBundlePrice } from './bundleHelpers';
import { BundlePricePortal } from './BundlePricePortal';
import YarnOptions from './YarnOptions';
import SizeOptions from './SizeOptions';
import GalleryCarousel from './GalleryCarousel';
import YarnModal from './YarnModal';
import { IconCross, IconTick } from '../icons/Icons';
import NextButton from './NextButton';
import { IconGallery } from '../icons/Icons';
import { IconWand } from '../icons/Icons';
import DynamicImage from './DynamicImage';
const initialSelectedState = {
    colours: [],
    variant: null,
    addOns: [],
};
const bundlePriceInitial = {
    totalBase: null,
    totalCompare: null,
    colours: [],
    addons: [],
};
const CustomiserBase = ({ title, display_name, gallery, currency, locale, selected_or_first_available_variant, translations, details, size_guide, base_image, images_cache, variants, addons, custom_accordions, included_tools, options, sold_out_badge, predefined_colours, id, featured_image, productRating, hide_dynamic_content, }) => {
    var _a, _b, _c;
    // Current bundle
    const [currentBundle, setCurrentBundle] = useState(initialSelectedState);
    const [containsPreorder, setContainsPreorder] = useState(false);
    const [isCustomisable, setIsCustomisable] = useState(true);
    const [activeAccordion, setActiveAccordion] = useState('details');
    const [accordionOptions, setAccordionOptions] = useState(['details']);
    const [activeYarnColour, setActiveYarnColour] = useState(0);
    // Pricing
    const [baseColourPrice, setBaseColourPrice] = useState(0); // Used for swatch surcharge prices
    const [baseColourComparePrice, setBaseColourComparePrice] = useState(0);
    const [bundlePrice, setBundlePrice] = useState(bundlePriceInitial);
    const [soldOut, setSoldOut] = useState(false);
    // Modals
    const [sizeChartModalOpen, setSizeChartModalOpen] = useState(false);
    const [yarnModalOpen, setYarnModalOpen] = useState(false);
    const [activeYarn, setActiveYarn] = useState(0);
    // Dynamic Images
    const imageWrapper = useRef(null);
    const imageContainer = useRef(null);
    const [isIntersecting, setIntersecting] = useState(false);
    const [inDesignMode, setInDesignMode] = useState(true);
    // Loading State
    const [addingToCart, setAddingToCart] = useState(false);
    const [bundleLoaded, setBundleLoaded] = useState(false);
    // Media Shelf
    const [shrinkMediaContainer, setShrinkMediaContainer] = useState(false);
    // Accordions
    const accordionsContainer = useRef(null);
    const accordionSelectors = {
        accordion: '[data-accordion]',
        accordionTitle: '.accordion__title',
        accordionBodyContent: '.body__content',
        mediaContainer: '.cg-product-hero__media',
    };
    const [showSizeOptions] = useState(options.find((option) => option.name.toLowerCase() == 'size' && option.values.length > 1));
    const [showYarnOptions] = useState(options.find((option) => option.name == '_yarn'));
    const [showColourOptions, setShowColourOptions] = useState(true);
    // Custom Accordions
    const [customAccordions, setCustomAccordons] = useState([]);
    // Ratings
    const [productRatingHtmlElement, setProductRatingHtmlElement] = useState(productRating || '');
    const fullyDecodeHtmlString = (escapedStr) => {
        try {
            const jsonParsed = JSON.parse(escapedStr);
            const textarea = document.createElement('textarea');
            textarea.innerHTML = jsonParsed;
            return textarea.value;
        }
        catch (e) {
            console.error('Decoding error:', e);
            return 'Invalid HTML content';
        }
    };
    // Use Effect: First Load
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        const searchParams = new URLSearchParams(window.location.search);
        const sizeOption = options.find((option) => option.name.toLowerCase() == 'size');
        let selectedVariant = variants.find((variant) => variant.id == selected_or_first_available_variant);
        const variantInURL = searchParams.get('variant');
        if (variantInURL) {
            selectedVariant = variants.find((variant) => variant.id == Number(variantInURL));
        }
        if (!selectedVariant)
            return null;
        let selectedAddons = [];
        // Check for colours in the URL
        const selectedColourIds = [];
        let selectedColours = [];
        // Collect all `colour` params from the URL (handles multiple `colour` keys)
        for (const [key, value] of searchParams.entries()) {
            if (key.toLowerCase().startsWith('colour')) {
                selectedColourIds.push(parseInt(value, 10));
            }
        }
        // If there are colours in the URL
        if (selectedColourIds.length) {
            selectedColours = (_a = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.yarn_group) === null || _a === void 0 ? void 0 : _a.yarn_colours.map((colour, index) => {
                const isInURL = searchParams.get(`colour${index + 1}`);
                let selectedCol = null;
                if (isInURL) {
                    selectedCol = colour.swatches.find((swatch) => swatch.id === Number(isInURL));
                }
                else {
                    selectedCol = pickRandomColour(colour.swatches);
                }
                if (!selectedCol) {
                    selectedCol = pickRandomColour(colour.swatches);
                }
                return selectedCol;
            });
        }
        else if (predefined_colours.length) {
            // If predefined colours
            const variantWithColour = variants.find((variant) => { var _a; return variant.options.includes(selectedVariant.options[sizeOption.position - 1]) && ((_a = variant.yarn_group) === null || _a === void 0 ? void 0 : _a.yarn_colours.some((colour) => colour.swatches.some((swatch) => swatch.id == predefined_colours[0].id))); });
            if (variantWithColour) {
                selectedVariant = variantWithColour;
                setURLParam('variant', selectedVariant.id);
            }
            selectedColours = (_b = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.yarn_group) === null || _b === void 0 ? void 0 : _b.yarn_colours.map((colour, index) => {
                let selectedCol = null;
                const hasColour = colour.swatches.find((swatch) => { var _a; return swatch.title === ((_a = predefined_colours[index]) === null || _a === void 0 ? void 0 : _a.title); });
                if (hasColour) {
                    selectedCol = hasColour;
                }
                else {
                    selectedCol = pickRandomColour(colour.swatches);
                }
                return selectedCol;
            });
        }
        else if ((_d = (_c = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.yarn_group) === null || _c === void 0 ? void 0 : _c.yarn_colours) === null || _d === void 0 ? void 0 : _d.length) {
            selectedColours = (_e = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.yarn_group) === null || _e === void 0 ? void 0 : _e.yarn_colours.map((colour, index) => {
                return pickRandomColour(colour.swatches);
            });
        }
        if (addons.length) {
            const addOnsInURL = getURLParam('addon');
            let preSelectedAddons;
            if (addOnsInURL) {
                const allAddOns = addOnsInURL.split('-');
                preSelectedAddons = addons.filter((addOn) => allAddOns.includes(addOn.id.toString()));
            }
            else {
                preSelectedAddons = addons.filter((addOn) => addOn.pre_selected);
            }
            if (preSelectedAddons.length) {
                selectedAddons = preSelectedAddons;
                setURLParam('addon', selectedAddons.length > 1 ? selectedAddons.map((item) => item.id).join('-') : selectedAddons[0].id);
            }
        }
        window.addEventListener('scroll', () => {
            if (window.scrollY > 100) {
                setIntersecting(true);
            }
            else {
                setIntersecting(false);
            }
        });
        // Bundle loaded
        const skeleton = document.querySelector('.bundle-skeleton');
        if (skeleton) {
            skeleton.classList.add('bundle-skeleton-hide');
            setBundleLoaded(true);
        }
        // Set Colours or Yarn Item
        const isSetColours = (_g = (_f = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.yarn_group) === null || _f === void 0 ? void 0 : _f.yarn_colours) === null || _g === void 0 ? void 0 : _g.every((colour) => colour.swatches.length == 1);
        if (!selectedColours.length) {
            setInDesignMode(false);
            setIsCustomisable(false);
        }
        if (!!isSetColours) {
            setInDesignMode(false);
            setShowColourOptions(false);
        }
        if (!!hide_dynamic_content) {
            setInDesignMode(false);
        }
        // Accordions
        const accOptions = accordionOptions;
        if (details.kit_elements.length > 0) {
            accOptions.push('kit-details');
        }
        if (showYarnOptions) {
            accOptions.push('yarn');
        }
        if (showSizeOptions) {
            accOptions.push('size');
        }
        if (!isSetColours) {
            accOptions.push('colours');
        }
        if (addons.length) {
            accOptions.push('extras');
        }
        setAccordionOptions(accOptions);
        setCustomAccordons(custom_accordions);
        setCurrentBundle({
            colours: selectedColours,
            variant: selectedVariant,
            addOns: selectedAddons,
        });
    }, []);
    const checkIfAllOOS = (swatchesArray) => {
        return swatchesArray.find((swatch) => swatch.available);
    };
    const calculatePrices = () => {
        var _a;
        const prices = calculateBundlePrice(currentBundle, true, included_tools);
        const firstColours = (_a = currentBundle.variant.yarn_group) === null || _a === void 0 ? void 0 : _a.yarn_colours;
        // Set base yarn price
        if (firstColours) {
            const baseColPrice = firstColours[0].swatches.map((item) => item.price).reduce((a, b) => Math.min(a, b));
            const baseColComparePrice = firstColours[0].swatches.map((item) => item.compare_at_price).reduce((a, b) => Math.min(a, b));
            setBaseColourPrice(baseColPrice);
            setBaseColourComparePrice(baseColComparePrice);
        }
        setBundlePrice(prices);
    };
    // Use Effect - Current Bundle Updated
    useEffect(() => {
        let isPreorder = false;
        let isOutOfStock = false;
        // Update pricing
        if (currentBundle.variant) {
            calculatePrices();
            if (currentBundle.variant.preorder_message) {
                isPreorder = true;
            }
            if (!currentBundle.variant.available) {
                isOutOfStock = true;
            }
        }
        // Check if in stock
        if (isCustomisable) {
            const outOfStock = currentBundle.colours.some((colour) => !colour || !colour.available);
            const outOfStockTools = included_tools.some((tool) => !tool.available);
            isOutOfStock = outOfStock || outOfStockTools;
        }
        if (currentBundle.colours.length) {
            if (currentBundle.colours.some((colour) => colour.preorder_message)) {
                isPreorder = true;
            }
        }
        setContainsPreorder(isPreorder);
        setSoldOut(isOutOfStock);
        // Dispatch event to update image
        window.dispatchEvent(new CustomEvent('bundle-colours-changed', { bubbles: true, detail: currentBundle.colours }));
    }, [currentBundle]);
    const prepareAddToCartData = () => {
        var _a, _b, _c, _d, _e, _f;
        const timeStamp = Date.now();
        let setColours = [], setAddOns = [], setIncludedTools = [];
        if (isCustomisable) {
            setColours = (_b = (_a = currentBundle.variant.yarn_group) === null || _a === void 0 ? void 0 : _a.yarn_colours) === null || _b === void 0 ? void 0 : _b.map((colour, index) => {
                const itemWithProperties = {
                    id: currentBundle.colours[index].id,
                    quantity: colour.quantity,
                    properties: {
                        _kit: title,
                        _time: timeStamp,
                        _element: `Colour ${index + 1}`,
                        _colour_swatch: currentBundle.colours[index].title,
                    },
                };
                if (currentBundle.colours[index].preorder_message) {
                    itemWithProperties.properties['_pre_order'] = currentBundle.colours[index].preorder_message;
                    itemWithProperties.properties['Note'] = currentBundle.colours[index].preorder_message;
                }
                return itemWithProperties;
            });
        }
        setAddOns = currentBundle.addOns.map((addOn, index) => {
            return {
                id: addOn.id,
                quantity: 1,
                properties: {
                    _addon: title,
                },
            };
        });
        setIncludedTools = included_tools.map((included_tool, index) => {
            return {
                id: included_tool.id,
                quantity: 1,
                properties: {
                    _kit: title,
                    _time: timeStamp,
                    _element: `Tool ${index + 1}`,
                    _included_tool: title,
                },
            };
        });
        const baseProduct = {
            id: currentBundle.variant.id,
            quantity: 1,
            properties: {},
        };
        if (isCustomisable) {
            baseProduct.properties['_kit'] = title;
            baseProduct.properties['_time'] = timeStamp;
            baseProduct.properties['_element'] = 'Base';
        }
        if (currentBundle.variant.preorder_message) {
            baseProduct.properties['_pre_order'] = currentBundle.variant.preorder_message;
        }
        if (currentBundle.variant.yarn_group) {
            baseProduct.properties[`_yarn`] = (_d = (_c = currentBundle.variant.yarn_group) === null || _c === void 0 ? void 0 : _c.yarn_info) === null || _d === void 0 ? void 0 : _d.name;
            (_f = (_e = currentBundle.variant.yarn_group) === null || _e === void 0 ? void 0 : _e.yarn_colours) === null || _f === void 0 ? void 0 : _f.forEach((colour, index) => {
                baseProduct.properties[`_colour_${index + 1}`] = currentBundle.colours[index].title;
            });
        }
        if (included_tools.length) {
            included_tools.forEach((tool, index) => {
                baseProduct.properties[`_included_tool_${index + 1}`] = tool.title;
            });
        }
        const selectedOptionsData = [baseProduct, ...setColours, ...setIncludedTools, ...setAddOns];
        return selectedOptionsData;
    };
    const addBundleToCart = () => {
        setAddingToCart(true);
        const productsToAdd = prepareAddToCartData();
        cartUtil
            .add(productsToAdd)
            .then(() => {
            setAddingToCart(false);
        })
            .catch(() => setAddingToCart(false));
    };
    const pickRandomColour = (colourArray) => {
        const randomIndex = Math.floor(Math.random() * colourArray.length);
        const hasAvailable = checkIfAllOOS(colourArray);
        if (hasAvailable) {
            if (!colourArray[randomIndex].available) {
                return pickRandomColour(colourArray);
            }
        }
        return colourArray[randomIndex];
    };
    const selectColour = (variantID, yarnColourIndex) => {
        const yarnColours = currentBundle.variant.yarn_group.yarn_colours[yarnColourIndex];
        const newColour = yarnColours.swatches.find((variant) => variant.id == variantID);
        setCurrentBundle((prevBundle) => (Object.assign(Object.assign({}, prevBundle), { colours: prevBundle.colours.map((colour, index) => (index == yarnColourIndex ? newColour : colour)) })));
    };
    const selectSize = (newVariant) => {
        setURLParam('variant', newVariant.id);
        const newColours = [];
        currentBundle.colours.forEach((currentCol, index) => {
            let newCol = newVariant.yarn_group.yarn_colours[index].swatches.find((col) => col.yarn_colour == currentCol.yarn_colour);
            if (!newCol) {
                if (!newCol) {
                    newCol = pickRandomColour(newVariant.yarn_group.yarn_colours[index].swatches);
                }
            }
            newColours.push(newCol);
        });
        setCurrentBundle((prevBundle) => (Object.assign(Object.assign({}, prevBundle), { variant: newVariant, colours: newColours })));
    };
    // UseEffect - Colours Updated
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        currentBundle.colours.forEach((colour, index) => {
            if (!colour)
                return;
            const currentValue = searchParams.get(`colour${index + 1}`);
            if (currentValue && Number(currentValue) == colour.id)
                return null;
            return setURLParam(`colour${index + 1}`, colour.id);
        });
    }, [currentBundle.colours]);
    const randomiseColours = () => {
        const randomColours = currentBundle.variant.yarn_group.yarn_colours.map((colour) => {
            return pickRandomColour(colour.swatches);
        });
        randomColours.forEach((colour, index) => {
            setURLParam(`colour${index + 1}`, colour.id);
        });
        setCurrentBundle((prevBundle) => (Object.assign(Object.assign({}, prevBundle), { colours: randomColours })));
    };
    const handleCloseModal = (modal) => {
        if (modal === 'size-chart') {
            setSizeChartModalOpen(false);
        }
        unlockBody();
    };
    const removeAddOn = (addOnToDelete) => {
        const addOnsInUrl = getURLParam('addon').split('-');
        if (addOnsInUrl.length <= 1) {
            deletURLParam('addon');
        }
        else {
            const remainingAddOns = addOnsInUrl.filter((addonID) => Number(addonID) != addOnToDelete);
            setURLParam('addon', remainingAddOns.length > 1 ? remainingAddOns.join('-') : remainingAddOns[0]);
        }
        setCurrentBundle((prevBundle) => (Object.assign(Object.assign({}, prevBundle), { addOns: currentBundle.addOns.filter((item) => item.id != addOnToDelete) })));
        handleCloseModal('add-on');
    };
    const addAddOnItem = (id) => {
        const inBundle = currentBundle.addOns.filter((item) => item.id === id);
        if (inBundle.length) {
            removeAddOn(id);
        }
        else {
            const addOnToAdd = addons.filter((item) => item.id === id);
            const newAddOns = [...currentBundle.addOns, ...addOnToAdd];
            const addonsURL = newAddOns.map((addOnItem) => addOnItem.id).join('-');
            setURLParam('addon', addonsURL);
            setCurrentBundle((prevBundle) => (Object.assign(Object.assign({}, prevBundle), { addOns: newAddOns })));
        }
    };
    const selectYarn = (newVariant) => {
        setURLParam('variant', newVariant.id);
        const newColours = [];
        currentBundle.colours.forEach((currentCol, index) => {
            let newCol = newVariant.yarn_group.yarn_colours[index].swatches.find((col) => col.yarn_colour == currentCol.yarn_colour);
            if (!newCol) {
                newCol = pickRandomColour(newVariant.yarn_group.yarn_colours[index].swatches);
            }
            newColours.push(newCol);
        });
        setCurrentBundle((prevBundle) => (Object.assign(Object.assign({}, prevBundle), { variant: newVariant, colours: newColours })));
    };
    const openYarnModal = (yarnIndex) => {
        setYarnModalOpen(true);
        setActiveYarn(yarnIndex);
    };
    // Accordions
    useEffect(() => {
        if (accordionsContainer && accordionsContainer.current) {
            const setMaxHeights = () => {
                const accordions = accordionsContainer.current.querySelectorAll(accordionSelectors.accordion);
                accordions.forEach((accordion) => {
                    const bodyContent = accordion.querySelector(accordionSelectors.accordionBodyContent);
                    if (bodyContent) {
                        accordion.style.setProperty('--max-height', `${bodyContent.scrollHeight + 16}px`);
                    }
                });
            };
            setMaxHeights();
            window.addEventListener('resize', () => {
                setMaxHeights();
            });
        }
    }, [accordionSelectors, accordionsContainer, accordionsContainer.current]);
    const goToNextAccordion = () => {
        const currentIndex = accordionOptions.indexOf(activeAccordion);
        openAccordion(accordionOptions[currentIndex + 1]);
    };
    const openAccordion = (targetAccordion) => {
        const isMobile = window.innerWidth < 1024;
        const currentAccordion = document.querySelector(`[data-accordion="${activeAccordion}"] .accordion__body`);
        if (!currentAccordion) {
            setActiveAccordion(targetAccordion);
            return;
        }
        if (isMobile) {
            // Allow closing of accordion
            if (activeAccordion == targetAccordion) {
                setActiveAccordion('');
                return;
            }
        }
        else {
            if (activeAccordion == targetAccordion || !currentAccordion)
                return null;
        }
        if (isMobile) {
            currentAccordion.style.transition = 'none';
            document.documentElement.style.scrollBehavior = 'auto !important';
            setTimeout(() => {
                window.scrollTo(0, 0);
                setTimeout(() => {
                    setActiveAccordion('');
                }, 200);
                setTimeout(() => {
                    currentAccordion.style.transition = 'opacity 0.3s ease, max-height 0.3s ease';
                    setActiveAccordion(targetAccordion);
                    document.documentElement.style.scrollBehavior = 'smooth';
                }, 600);
            }, 10);
        }
        else {
            setActiveAccordion(targetAccordion);
        }
    };
    // Open first Accordion on Desktop (if none are open)
    useEffect(() => {
        window.addEventListener('resize', () => {
            const isDesktop = window.innerWidth >= 1024;
            const currentAccordion = document.querySelector(`[data-accordion="${activeAccordion}"] .accordion__body`);
            if (!currentAccordion && isDesktop) {
                setActiveAccordion('details');
            }
        });
    }, [activeAccordion]);
    if (!currentBundle.variant || !bundlePrice.totalBase) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `cg-product-hero__media ${!!inDesignMode ? 'cg-product-hero__media--design-mode' : 'cg-product-hero__media--gallery'}` },
            React.createElement("div", { className: "media__inner" },
                React.createElement("h1", null,
                    React.createElement("span", null, display_name)),
                React.createElement("button", { className: `media-shelf-toggle ${shrinkMediaContainer ? `media-shelf-toggle--closed` : ''}`, onClick: () => {
                        setShrinkMediaContainer(!shrinkMediaContainer);
                    } },
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1080 1080" },
                        React.createElement("path", { d: "M1080,0c0,596.95-483.05,1080-1080,1080H1080V0Z" })),
                    React.createElement("div", null,
                        React.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                            React.createElement("path", { d: "M8.86328 7.5L5.86328 4.5L2.86328 7.5", strokeWidth: "0.75", strokeLinecap: "round", strokeLinejoin: "round" }))),
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1080 1080" },
                        React.createElement("path", { d: "M0,0C0,596.95,483.05,1080,1080,1080H0V0Z" }))),
                React.createElement("div", { className: `media-container ${shrinkMediaContainer ? `media-container--small` : ''}` },
                    gallery.length > 0 && isCustomisable && showColourOptions && !hide_dynamic_content ? (React.createElement("div", { className: "media-toggle" },
                        React.createElement("button", { className: `media-toggle__btn ${!!inDesignMode ? 'media-toggle__btn--active' : ''}`, onClick: () => setInDesignMode(true) },
                            React.createElement("span", null, translations.editor_toggle_button),
                            React.createElement(IconWand, null)),
                        React.createElement("button", { className: `media-toggle__btn ${!inDesignMode ? 'media-toggle__btn--active' : ''}`, onClick: () => setInDesignMode(false) },
                            React.createElement("span", null, translations.gallery_toggle_button),
                            React.createElement(IconGallery, null)))) : null,
                    React.createElement("div", { className: "add-to-cart" },
                        containsPreorder ? React.createElement("span", { className: "add-to-cart__preorder-message" }, "Pre-order") : null,
                        React.createElement("button", { onClick: addBundleToCart, className: `add-to-cart__btn ${addingToCart ? 'loading' : ''}`, disabled: addingToCart || soldOut, "data-cg-add-to-cart": "" },
                            React.createElement("span", null, soldOut ? translations.sold_out : translations.add_to_cart),
                            React.createElement("span", null, formattedMoney(bundlePrice.totalBase)))),
                    React.createElement("div", { className: "media-container__inner" }, isCustomisable && showColourOptions && !hide_dynamic_content ? (React.createElement(React.Fragment, null,
                        gallery.length > 0 ? React.createElement(GalleryCarousel, { media: gallery }) : null,
                        React.createElement(DynamicImage, { currentBundle: currentBundle, kitTitle: title, baseImage: base_image, imagesCache: images_cache }))) : (
                    // Just Gallery
                    React.createElement(React.Fragment, null, gallery.length > 0 ? React.createElement(GalleryCarousel, { media: gallery }) : null)
                    // <img src={featured_image} alt={title} className='media-container__single-image' />
                    ))))),
        React.createElement("div", { ref: accordionsContainer, className: "cg-product-hero__accordions" },
            React.createElement("div", { "data-accordion": "details", className: `accordion accordion--details ${activeAccordion == 'details' ? 'accordion--active' : ''}` },
                React.createElement("div", { className: "accordion__title", onClick: () => openAccordion('details') },
                    React.createElement("span", null, translations.details_accordion_title)),
                React.createElement("div", { className: "accordion__body" },
                    React.createElement("div", { className: "body__content" },
                        React.createElement("div", { className: "details__column" },
                            productRatingHtmlElement != '' ? (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "details__reviews", dangerouslySetInnerHTML: { __html: fullyDecodeHtmlString(productRatingHtmlElement) } }))) : null,
                            details.stickers.length > 0 ? (React.createElement("div", { className: "stickers" }, details.stickers.map((sticker) => (React.createElement("img", { src: `${window.Shopify.routes.root}${sticker.image}`, alt: sticker.name, key: sticker.name }))))) : null,
                            React.createElement(BundlePricePortal, { price: bundlePrice.totalBase, compare_at_price: bundlePrice.totalCompare, translations: translations, currency: currency, locale: locale })),
                        details.description ? (React.createElement("div", { className: "details__description", dangerouslySetInnerHTML: { __html: details.description } })) : null,
                        isCustomisable ? (React.createElement(NextButton, { text: translations.details_accordion_next_btn, goToNextAccordion: goToNextAccordion })) : null))),
            details.kit_elements.length > 0 ? (React.createElement("div", { "data-accordion": "kit-details", className: `accordion accordion--kit-details ${activeAccordion == 'kit-details' ? 'accordion--active' : ''}` },
                React.createElement("div", { className: "accordion__title", onClick: () => openAccordion('kit-details') },
                    React.createElement("span", null, translations.kit_details_accordion_title)),
                React.createElement("div", { className: "accordion__body" },
                    React.createElement("div", { className: "body__content" },
                        React.createElement("div", { className: "kit-details" },
                            React.createElement("h4", { className: "kit-details__title" }, translations.kit_elements_title),
                            React.createElement("div", { className: "kit-details__elements" }, details.kit_elements.map((kit_elem) => (React.createElement("div", { key: kit_elem.name, className: "kit-element" },
                                React.createElement("h5", null, kit_elem.name),
                                React.createElement("img", { src: kit_elem.image, alt: kit_elem.name })))))),
                        isCustomisable ? (React.createElement(NextButton, { text: translations.kit_details_accordion_next_btn, goToNextAccordion: goToNextAccordion })) : null)))) : null,
            showYarnOptions ? (React.createElement("div", { "data-accordion": "yarn", className: `accordion accordion--yarn ${activeAccordion == 'yarn' ? 'accordion--active' : ''}` },
                React.createElement("div", { className: "accordion__title", onClick: () => openAccordion('yarn') },
                    React.createElement("span", null, translations.yarn_accordion_title)),
                React.createElement("div", { className: "accordion__body" },
                    React.createElement("div", { className: "body__content" },
                        React.createElement("div", { className: "content-wrapper" },
                            React.createElement(YarnOptions, { currentVariant: currentBundle.variant, allVariants: variants, selectYarn: selectYarn, openYarnModal: openYarnModal })),
                        React.createElement(NextButton, { text: `Next: ${accordionOptions[accordionOptions.indexOf('yarn') + 1]}`, goToNextAccordion: goToNextAccordion }))))) : null,
            showSizeOptions ? (React.createElement("div", { "data-accordion": "size", className: `accordion accordion--size ${activeAccordion == 'size' ? 'accordion--active' : ''}` },
                React.createElement("div", { className: "accordion__title", onClick: () => openAccordion('size') },
                    React.createElement("span", null, translations.size_accordion_title)),
                React.createElement("div", { className: "accordion__body" },
                    React.createElement("div", { className: "body__content" },
                        React.createElement("div", { className: "content-wrapper" },
                            React.createElement("div", { className: "size-wrapper" },
                                React.createElement(SizeOptions, { currentVariant: currentBundle.variant, allVariants: variants, selectSize: selectSize })),
                            size_guide ? (React.createElement("button", { className: "size-guide-btn", onClick: () => setSizeChartModalOpen(true) }, "Size guide")) : null),
                        React.createElement(NextButton, { text: `Next: ${accordionOptions[accordionOptions.indexOf('size') + 1]}`, goToNextAccordion: goToNextAccordion }))))) : null,
            showColourOptions && ((_b = (_a = currentBundle.variant.yarn_group) === null || _a === void 0 ? void 0 : _a.yarn_colours) === null || _b === void 0 ? void 0 : _b.length) > 0 ? (React.createElement("div", { "data-accordion": "colours", className: `accordion accordion--colour ${activeAccordion == 'colours' ? 'accordion--active' : ''}` },
                React.createElement("div", { className: "accordion__title", onClick: () => openAccordion('colours') },
                    React.createElement("span", null, translations.colours_accordion_title)),
                React.createElement("div", { className: "accordion__body" },
                    React.createElement("div", { className: "body__content" },
                        React.createElement("div", { className: "content-wrapper" },
                            currentBundle.colours.length > 1 ? (React.createElement("div", { className: "yarn-colours" }, currentBundle.colours.map((yarn_colour, index) => (React.createElement("button", { className: `colour-btn ${activeYarnColour === index ? 'colour-btn--active' : ''}`, key: index, onClick: () => setActiveYarnColour(index) },
                                React.createElement("span", null, index + 1),
                                React.createElement("img", { src: yarn_colour.image, alt: yarn_colour.title })))))) : null,
                            React.createElement("div", { className: "swatch-colours" }, (_c = currentBundle.variant.yarn_group) === null || _c === void 0 ? void 0 : _c.yarn_colours.map((yarn_colour, yarnIndex) => (React.createElement("div", { className: `swatch-wrapper ${activeYarnColour === yarnIndex ? 'swatch-wrapper--active' : ''}`, key: yarnIndex }, yarn_colour.swatches.map((swatch) => (React.createElement("button", { className: `yarn-swatch ${currentBundle.colours.length && currentBundle.colours[yarnIndex].id === swatch.id ? 'yarn-swatch--active' : ''} yarn-swatch--${swatch.text_colour} ${!swatch.available ? 'yarn-swatch--oos' : ''}`, key: swatch.handle, onClick: () => selectColour(swatch.id, yarnIndex) },
                                React.createElement("img", { src: swatch.image, alt: swatch.title, className: "yarn-swatch__image" }),
                                React.createElement("span", null, swatch.title),
                                swatch.price > baseColourPrice ? React.createElement("span", { className: "yarn-swatch__surcharge-badge" },
                                    "+",
                                    formattedMoney(swatch.price - baseColourPrice)) : null,
                                currentBundle.colours.length && currentBundle.colours[yarnIndex].id === swatch.id ? React.createElement("span", { className: "yarn-swatch__selected-badge" }, yarnIndex + 1) : null,
                                sold_out_badge && !swatch.available ? (React.createElement("img", { alt: "Sold Out Badge", src: sold_out_badge, className: "yarn-swatch__sold-out-badge", style: { '--sold-out-badge-rotation': `${Math.floor(Math.random() * 81) - 40}deg` } })) : null,
                                swatch.preorder_message ? React.createElement("span", { className: "yarn-swatch__preorder-message" }, swatch.preorder_message) : null)))))))),
                        React.createElement(NextButton, { text: `Next: ${accordionOptions[accordionOptions.indexOf('colours') + 1]}`, goToNextAccordion: goToNextAccordion }))))) : null,
            addons.length ? (React.createElement("div", { "data-accordion": "extras", className: `accordion accordion--extras ${activeAccordion == 'extras' ? 'accordion--active' : ''}` },
                React.createElement("div", { className: "accordion__title", onClick: (e) => openAccordion('extras') },
                    React.createElement("span", null, translations.extras_accordion_title)),
                React.createElement("div", { className: "accordion__body" },
                    React.createElement("div", { className: "body__content" },
                        React.createElement("div", { className: "content-wrapper extras" },
                            translations.extras_title ? React.createElement("h3", { className: "extras__title" }, translations.extras_title) : null,
                            translations.extras_intro ? React.createElement("p", { className: "extras__intro" }, translations.extras_intro) : null,
                            React.createElement("div", { className: "extras__wrapper" }, addons.map((extraItem, index) => (React.createElement("div", { className: `extra${currentBundle.addOns.find((item) => item.id === extraItem.id) ? ' extra--selected' : ''}`, key: extraItem.id },
                                React.createElement("img", { src: extraItem.image, alt: extraItem.title }),
                                React.createElement("h3", { className: "extra__title" }, extraItem.title),
                                React.createElement("button", { className: `extra__btn`, onClick: () => addAddOnItem(extraItem.id) },
                                    React.createElement("span", null,
                                        "+",
                                        formattedMoney(extraItem.price),
                                        React.createElement(IconTick, null)))))))))))) : null, customAccordions === null || customAccordions === void 0 ? void 0 :
            customAccordions.map((accordion, i) => accordion.body && (React.createElement("div", { key: i, "data-accordion": accordion.handle, className: `accordion accordion--custom accordion--${accordion.handle} ${activeAccordion == accordion.handle ? 'accordion--active' : ''}` },
                React.createElement("div", { className: "accordion__title", onClick: () => openAccordion(accordion.handle) },
                    React.createElement("span", null, accordion.title)),
                (() => {
                    if (!accordion.body)
                        return;
                    const decodeHtml = (html) => {
                        const txt = document.createElement('textarea');
                        txt.innerHTML = html;
                        return txt.value;
                    };
                    const decodedHtml = decodeHtml(accordion.body);
                    return (React.createElement("div", { className: `accordion__body accordion__body--mobile-${accordion.mobile_text_alignment} accordion__body--desktop-${accordion.desktop_text_alignment}` },
                        React.createElement("div", { className: "body__content rte" },
                            React.createElement("div", { dangerouslySetInnerHTML: { __html: decodedHtml } }),
                            accordion.columns.length ? (React.createElement("div", { className: `body__columns body__columns--${accordion.columns.length}` }, accordion.columns.map((column, columnIndex) => (React.createElement(React.Fragment, null,
                                React.createElement("div", { key: columnIndex, className: `column__title column__title--${columnIndex + 1}` }, column.column_title),
                                React.createElement("div", { key: columnIndex, className: `column__image column__image--${columnIndex + 1}` }, column.column_image && (React.createElement("img", { src: `https:${column.column_image}`, width: 500, height: 500, alt: column.column_title || '' }))),
                                React.createElement("div", { key: columnIndex, className: `column__content column__content--${columnIndex + 1}`, dangerouslySetInnerHTML: { __html: decodeHtml(column.column_content) } })))))) : null)));
                })()))),
            React.createElement("div", { className: "accordion accordion--add-to-cart" },
                React.createElement("div", { className: "accordion__title" },
                    React.createElement("button", { onClick: addBundleToCart, className: `add-to-cart ${addingToCart ? 'loading' : ''}`, disabled: addingToCart || soldOut, "data-cg-add-to-cart": "" }, addingToCart ? (React.createElement("div", { className: "lds-heart" },
                        React.createElement("div", null))) : (React.createElement(React.Fragment, null,
                        React.createElement("span", null, soldOut ? translations.sold_out : translations.add_to_cart))))))),
        showYarnOptions ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: `cg-product-hero__yarn-modal ${yarnModalOpen ? 'cg-product-hero__yarn-modal--active' : ''}` },
                React.createElement(YarnModal, { currentVariant: currentBundle.variant, allVariants: variants, activeYarnItem: activeYarn, closeModal: () => setYarnModalOpen(false) })),
            React.createElement("div", { className: `yarn-modal-underlay ${yarnModalOpen ? 'yarn-modal-underlay--active' : ''}`, onClick: () => setYarnModalOpen(false) }))) : null,
        showSizeOptions && size_guide != '' ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: `cg-product-hero__size-modal ${sizeChartModalOpen ? 'cg-product-hero__size-modal--active' : ''}` },
                React.createElement("div", { className: "size-modal" },
                    React.createElement("button", { className: "size-modal__close", onClick: () => setSizeChartModalOpen(false) },
                        React.createElement(IconCross, null)),
                    React.createElement("img", { src: size_guide, alt: "Size Guide" }))),
            React.createElement("div", { className: `size-modal-underlay ${sizeChartModalOpen ? 'size-modal-underlay--active' : ''}`, onClick: () => setSizeChartModalOpen(false) }))) : null));
};
export default CustomiserBase;
